export const SECTION_STATE_NORMALIZATION = {
  "not_started": "Keskeneräinen",
  "not_ready": "Ei valmis",
  "ready": "Valmis"
};

export const REPORT_STATE_NORMALIZATION = {
  "draft": "Keskeneräinen",
  "ready": "Valmis",
  "archived": "Arkistoitu"
};

// Cover page's Tila field only has two options (luonnos/lopullinen), coarser
// than report.state's three — only "draft" reads as unfinished; "ready" and
// "archived" both print as "lopullinen" (an archived report was finished
// before it was shelved, not reopened as a draft).
export const deriveCoverStatus = (reportState) => reportState === "draft" ? "luonnos" : "lopullinen";

